import { createFileRoute } from "@tanstack/react-router";

import {
  Layout,
  LayoutAside,
  LayoutBody,
  LayoutContent,
  LayoutHeader,
} from "@/client/components/layout";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/client/components/shad/breadcrumb";
import { SkopaPlatformForm } from "@/client/forms/skopa";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/client/components/shad/card";
import { Badge } from "@/client/components/shad/badge";

export const Route = createFileRoute("/(protected)/settings/skopa/config")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Layout>
      <LayoutHeader>
        <Breadcrumb>
          <BreadcrumbList className="font-bold text-base">
            <BreadcrumbItem>
              <BreadcrumbPage>Skopa</BreadcrumbPage>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>Config</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </LayoutHeader>
      <LayoutContent>
        <LayoutBody>
          <SkopaPlatformForm />
        </LayoutBody>
        <LayoutAside>
          <div className="h-full animate-in fade-in duration-500">
            <Card>
              <CardHeader>
                <CardTitle>
                  Skopa status{" "}
                  <Badge className="bg-lime-50 text-lime-700 dark:bg-lime-950 dark:text-lime-300">
                    Active
                  </Badge>
                </CardTitle>
                <CardDescription>
                  Descripting for the current status of Skopa
                </CardDescription>
              </CardHeader>
              <CardContent>Status content</CardContent>
            </Card>
          </div>
        </LayoutAside>
      </LayoutContent>
    </Layout>
  );
}
